// @flow

import type {ApiSuccess} from '@travel-frontend/state-handling-sdk';
import type {Description} from 'redux/tourOperator/models';
import type {AsyncAction} from 'redux/types';
import type {TourOperatorRequestParams} from 'redux/v1/journey/models';

import {ASYNC_TYPES} from '@travel-frontend/state-handling-sdk';
import axios from 'axios';
import {format} from 'date-fns';

import {config as cfg} from 'config';

export const FETCH_TOUR_OPERATOR_DESCRIPTION =
  'tourOperator/FETCH_TOUR_OPERATOR_DESCRIPTION';

export type FetchTourOperatorDescriptionSuccess = ApiSuccess<Description, *>;

export function fetchTourOperatorDescription({
  hotelId,
  organizer,
  departureDate,
  returnDate,
  port,
  bookingCode,
}: TourOperatorRequestParams): AsyncAction {
  const requestParams = new URLSearchParams({
    hotel: `${hotelId}-giata`,
    tourOperator: organizer,
    dateMin: format(Date.parse(departureDate), 'yyyy-MM-dd'),
    dateMax: format(Date.parse(returnDate), 'yyyy-MM-dd'),
    travelType: port === 653 ? 'ownArrival' : 'packageTour',
    serviceCode: bookingCode,
  });

  return {
    types: ASYNC_TYPES(FETCH_TOUR_OPERATOR_DESCRIPTION),
    callAPI: () =>
      axios
        .get(
          `${
            cfg.findBffUrl
          }/tour-operator-description?${requestParams.toString()}`
        )
        .then((res) => res.data),
  };
}
